gsap.registerPlugin(ScrollToPlugin);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const getOverlay = () => {
  const overlay = document.querySelector('[data-modal-overlay]');

  if (overlay) return overlay;

  const overlayElement = document.createElement('div');
  overlayElement.classList.add('modal-overlay', 'modal-overlay--primary');
  overlayElement.dataset.modalOverlay = true;
  document.body.appendChild(overlayElement);

  return overlayElement;
};

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  elementToFocus ??= container;

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/**
 * @param {HTMLElement|null} [elementToFocus]
 */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const viewportSizes = {
  ['mobile']: [null, 749],
  ['tablet']: [750, 989],
  ['tablet-large']: [990, 1199],
  ['desktop']: [1200, 1439],
  ['desktop-large']: [1440, null],
};
function breakpointQuery(breakpoint, type = 'min') {
  if (!viewportSizes[breakpoint]) {
    console.error(`Invalid breakpoint: ${breakpoint}`);
    return;
  }

  if (!['min', 'max'].includes(type)) {
    console.error(`Invalid query type: ${type}`);
    return;
  }

  const [min, max] = viewportSizes[breakpoint];
  let target = type === 'min' ? min : max;

  if (!target) {
    console.error(
      `Failed to create ${type}-width query: Breakpoint "${breakpoint}" has no ${type}-width`,
    );
    return;
  }

  return `(${type}-width: ${target}px)`;
}

class QuantityBase extends ElementBase {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });

    // this.add
  }

  // TODO: Merge with individual defaults on children
  defaults() {
    return {
      connected: true,
      productId: null,
      variantId: null,
    };
  }

  static get observedAttributes() {
    return ['variant-id'];
  }

  connectedCallback() {
    if (this.input) {
      this.addListener(this.input, 'change', this.onInputChange);
    }

    super.connectedCallback();
  }

  init() {
    super.init();

    if (this.options.connected) {
      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        e => {
          if (e.data.productId === this.options.productId) {
            this.setAttribute('variant-id', e.data.variant.id);
          }
        },
      );

      this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        e => {
          const { source, variantId, value } = e.data;
          if (!variantId || !value || source === this) return;

          if (variantId === this.options.variantId) {
            this.setValue(value);
          }
        },
      );
    }
  }

  onInputChange(event) {
    publish(PUB_SUB_EVENTS.quantityUpdate, {
      data: {
        source: this,
        variantId: this.options.variantId,
        value: event.target.value,
      },
    });
  }

  setValue(value) {
    if (!this.input) return;

    const previousValue = this.input.value;

    this.input.value = value;

    if (previousValue !== this.input.value) {
      this.dispatchInputEvent();
    }
  }

  dispatchInputEvent() {
    this.input?.dispatchEvent(this.changeEvent);
  }
}

class QuantityInput extends QuantityBase {
  constructor() {
    super();
    this.input = this.querySelector('input');

    this.addEvents();
  }

  addEvents() {
    this.addDelegatedListener(this, 'button', 'click', this.onButtonClick);
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.dispatchInputEvent();
  }
}

customElements.define('quantity-input', QuantityInput);

class QuantitySelect extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('ui-select');

    if (!this.input) {
      throw new Error('<QuantitySelect> has no <ui-select> child element.');
    }

    this.changeEvent = new Event('change', { bubbles: true });
  }

  connectedCallback() {
    this.input.addEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    publish(PUB_SUB_EVENTS.quantityUpdate, {
      data: {
        source: this,
        value: event.target.value,
      },
    });
  }
}

customElements.define('quantity-select', QuantitySelect);

class SubscriptionSelectWrapper extends HTMLElement {
  constructor() {
    super();
    this.quantity = 1;
    this.productType = this.dataset.productType || 'bottle';
    this.quantityUpdateUnsubscriber = undefined;
    this.quantitySelectChangeHandler = undefined;
  }

  connectedCallback() {
    // Find quantity selector - look in multiple places
    const form = this.closest('form');
    const productCard = this.closest('.product-card, .product-highlight__item');
    
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const quantitySelect = 
      productCard?.querySelector('ui-select[data-name="qty"]') ||
      form?.querySelector('ui-select[data-name="qty"]') ||
      document.querySelector(`ui-select[data-name="qty"]`);
    
    if (quantityInput) {
      this.quantity = Number(quantityInput.value) || 1;
    } else if (quantitySelect) {
      this.quantity = Number(quantitySelect.value) || 1;
    }

    // Store reference to quantity select for cleanup
    this.quantitySelectElement = quantitySelect;

    // Listen to quantity updates from quantity-input/quantity-select components
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      e => {
        const newQuantity = Number(e.data.value) || 1;
        if (this.quantity !== newQuantity) {
          this.quantity = newQuantity;
          this.updateSubscriptionText();
        }
      },
    );

    // Also listen directly to ui-select change events for quantity selectors
    if (quantitySelect) {
      this.quantitySelectChangeHandler = (e) => {
        const newQuantity = Number(e.target.value) || 1;
        if (this.quantity !== newQuantity) {
          this.quantity = newQuantity;
          this.updateSubscriptionText();
        }
      };
      quantitySelect.addEventListener('change', this.quantitySelectChangeHandler);
    }

    // Listen to ui-select changes to update trigger display
    const uiSelect = this.querySelector('ui-select');
    if (uiSelect) {
      uiSelect.addEventListener('change', () => {
        this.updateSubscriptionText();
      });
    }

    // Wait for ui-select to initialize, then do initial update
    requestAnimationFrame(() => {
      if (uiSelect && uiSelect.getAttribute('data-initialized') === 'true') {
        this.updateSubscriptionText();
      } else {
        setTimeout(() => {
          this.updateSubscriptionText();
        }, 100);
      }
    });
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantitySelectChangeHandler && this.quantitySelectElement) {
      this.quantitySelectElement.removeEventListener('change', this.quantitySelectChangeHandler);
    }
  }

  pluralize(word, count) {
    if (count === 1) return word;
    
    const last2 = word.slice(-2);
    const last1 = word.slice(-1);
    
    if (last1 === 'y') {
      return word.slice(0, -1) + 'ies';
    } else if (last2 === 'ch' || last2 === 'sh' || last1 === 's' || last1 === 'x' || last1 === 'z') {
      return word + 'es';
    } else {
      return word + 's';
    }
  }

  updateSubscriptionText() {
    const uiSelect = this.querySelector('ui-select');
    if (!uiSelect) return;

    // Update all ui-select-item elements (both in shadow DOM structure and original items)
    const selectItems = this.querySelectorAll('ui-select-item');
    const dropdownItems = uiSelect.querySelectorAll('.ui-select__item');
    
    // Update original ui-select-item elements
    selectItems.forEach(item => {
      const quantityTextElement = item.querySelector('[data-quantity-text]');
      if (quantityTextElement) {
        const interval = Number(quantityTextElement.dataset.interval) || 1;
        const totalQuantity = this.quantity * interval;
        const productTypeText = totalQuantity === 1 
          ? this.productType 
          : this.pluralize(this.productType, totalQuantity);
        
        if (interval === 1) {
          quantityTextElement.textContent = `${this.quantity} ${productTypeText} shipped every month`;
        } else if (interval === 3) {
          quantityTextElement.textContent = `${totalQuantity} ${productTypeText} shipped every 3 months`;
        }
      }
    });

    // Update dropdown items (the rendered .ui-select__item elements)
    dropdownItems.forEach(item => {
      const quantityTextElement = item.querySelector('[data-quantity-text]');
      if (quantityTextElement) {
        const interval = Number(quantityTextElement.dataset.interval) || 1;
        const totalQuantity = this.quantity * interval;
        const productTypeText = totalQuantity === 1 
          ? this.productType 
          : this.pluralize(this.productType, totalQuantity);
        
        if (interval === 1) {
          quantityTextElement.textContent = `${this.quantity} ${productTypeText} shipped every month`;
        } else if (interval === 3) {
          quantityTextElement.textContent = `${totalQuantity} ${productTypeText} shipped every 3 months`;
        }
      }
    });

    // Update the selected display (trigger button)
    const selectedTrigger = uiSelect.querySelector('.ui-select__selected');
    if (selectedTrigger) {
      const selectedValue = uiSelect.value;
      const selectedDropdownItem = uiSelect.querySelector(`.ui-select__item[value="${selectedValue}"]`);
      if (selectedDropdownItem) {
        // Update the trigger with the updated content from the dropdown item
        selectedTrigger.innerHTML = selectedDropdownItem.innerHTML;
      }
    }
  }
}

customElements.define('subscription-select-wrapper', SubscriptionSelectWrapper);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/** @returns {FetchConfig} */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    const parts = (number = (number / 100).toFixed(precision)).split('.');
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands,
    );
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`,
      );

    this.handleClick = this.onExternalClick.bind(this);
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    // this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button:not(.no-close)').forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary'),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      this.setDefaultMenu(summaryElement);
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  /**
   * @param {HTMLElement} summaryElement
   */
  setDefaultMenu(summaryElement) {}

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.addEventListener('click', this.handleClick);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      document.body.removeEventListener('click', this.handleClick);
    }
  }

  onExternalClick(event) {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (isOpen && !event.target.closest('.menu-drawer')) {
      this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector('summary'),
      );
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    /** @type {NodeListOf<HTMLElement>} */
    this.submenuToggles = this.querySelectorAll('.menu-drawer-item-toggle');
    /** @type {NodeListOf<HTMLElement>} */

    this.submenuParents = this.querySelectorAll('.submenu-wrapper');
    /** @type {NodeListOf<HTMLElement>} */

    this.submenus = this.querySelectorAll('.menu-item--child-links');

    this.tween = null;

    this.prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    );
  }

  connectedCallback() {
    this.submenuToggles.forEach(toggle => {
      toggle.addEventListener(
        'click',
        this.handleSubmenuToggleClick.bind(this),
      );
    });
  }

  /**
   * @param {HTMLElement} summaryElement
   */
  setDefaultMenu(summaryElement) {
    /** @type {HTMLElement} */
    // @ts-ignore
    const sibling = summaryElement.nextElementSibling;

    /** @type {HTMLElement|null} */
    const wrapper = sibling.querySelector('.submenu-wrapper');

    if (wrapper && !wrapper.classList.contains('is-expanded')) {
      this.selectSubmenu(wrapper);
    }
  }
  /**
   * @param {Event} event
   */
  handleSubmenuToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    /** @type {HTMLElement} */
    // @ts-ignore
    const target = event.currentTarget;

    /** @type {HTMLElement} */
    // @ts-ignore
    const parentContainer = target.parentElement;

    this.selectSubmenu(parentContainer);
  }

  /**
   * @param {HTMLElement} parentContainer
   */
  selectSubmenu(parentContainer) {
    /** @type {HTMLElement|null} */
    const menu = parentContainer.querySelector('.menu-item--child-links');

    if (!menu) {
      return;
    }

    const isAlreadyActive = parentContainer.classList.contains('is-expanded');

    this.submenuParents.forEach(container => {
      container.classList.remove('is-expanded');
    });

    if (this.tween) {
      this.tween.reverse();
      this.tween = null;
    }

    if (!isAlreadyActive) {
      parentContainer.classList.add('is-expanded');
      if (this.tween) {
        this.tween.reverse();
        this.tween = null;
      }

      const duration = this.prefersReducedMotion.matches ? 0 : 0.38;
      this.tween = gsap.fromTo(
        menu,
        { height: 0, opacity: 0 },
        { height: 'auto', duration, opacity: 1, ease: 'power2.inOut' },
      );
    }
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.addEventListener('click', this.handleClick);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.overlay = getOverlay();
    this.handleHide = this.hide.bind(this);
    this.querySelectorAll('[id^="ModalClose-"]').forEach(closeBtn =>
      closeBtn.addEventListener('click', this.hide.bind(this)),
    );

    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;

    this.overlay.addEventListener('click', this.handleHide);

    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden', 'has-open-dialog');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.overlay.removeEventListener('click', this.handleHide);

    document.body.classList.remove('overflow-hidden', 'has-open-dialog');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

// TODO: Add "loop" attribute and implement?
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.enableSliderLooping = false;
    this.sliderControlWrapper = this.querySelector('.slider__control-wrapper');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.connectedId = this.dataset.connectedSlider;
    this.connectedSliders = Array.from(
      document.querySelectorAll(
        `[data-connected-slider="${this.connectedId}"]`,
      ),
    ).filter(slider => slider !== this);
    this.thumbnailSlider = this.dataset.thumbnailSlider
      ? null
      : document.querySelector(`[data-thumbnail-slider="${this.connectedId}"]`);
    this.getItems();
    this.getControlLinks();
    this.initialized = false;
    this.locked = false;
    this.navigationQueue = [];

    this.throttledLock = throttle(this.lockPosition.bind(this), 1000);
    this.debouncedResize = debounce(
      () => this.initPages(),
      RESIZE_DEBOUNCE_TIMER,
    );
    this.handleResize = this.onResize.bind(this);
    this.debouncedConnectedSlideChange = debounce(
      this.onConnectedSlideChange.bind(this),
      SLIDE_CHANGE_DEBOUNCE_TIMER,
    );
    this.handleUpdate = this.update.bind(this);
    this.handleOrientationChange = this.changeOrientation.bind(this);
    this.handleButtonClick = this.onButtonClick.bind(this);
    this.handleNavigationQueue = this.runQueuedNavigation.bind(this);

    this.prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    );
  }

  connectedCallback() {
    if (!this.slider) return;

    this.initOrientation();

    if (this.constructor.name !== 'CardSlider') {
      this.initPages();

      this.initialized = true;
      this.dispatchEvent(
        new CustomEvent('sliderInitialized', {
          detail: {
            currentPage: this.currentPage,
            currentElements: this.currentElements,
            currentElement: this.currentElement,
          },
        }),
      );
    }

    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.handleUpdate);
    this.prevButton?.addEventListener('click', this.handleButtonClick);
    this.nextButton?.addEventListener('click', this.handleButtonClick);
    this.connectControlLinks();

    this.connectedSliders.forEach(slider =>
      slider.addEventListener(
        'slideChanged',
        this.debouncedConnectedSlideChange,
      ),
    );
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.slider.removeEventListener('scroll', this.handleUpdate);
    this.prevButton?.removeEventListener('click', this.handleButtonClick);
    this.nextButton?.removeEventListener('click', this.handleButtonClick);
    this.orientationMQL?.removeEventListener(
      'change',
      this.handleOrientationChange,
    );
    this.connectControlLinks(false);

    this.connectedSliders.forEach(slider =>
      slider.removeEventListener(
        'slideChanged',
        this.debouncedConnectedSlideChange,
      ),
    );
  }

  connectControlLinks(connect = true) {
    this.sliderControlLinksArray?.forEach(link =>
      connect
        ? link.addEventListener('click', this.linkToSlide.bind(this))
        : link.removeEventListener('click', this.linkToSlide.bind(this)),
    );
  }

  initPages() {
    this.releaseLock();

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element[this.measurement.size] > 0,
    );
    if (this.sliderItemsToShow.length > 0) this.currentPage ??= 1;
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1][this.measurement.offset] -
      this.sliderItemsToShow[0][this.measurement.offset];
    this.sliderGap =
      this.sliderItemOffset - this.sliderItemsToShow[1].clientWidth;
    this.slidesPerPage = Math.max(
      Math.floor(
        (this.slider[this.measurement.size] -
          this.sliderItemsToShow[0][this.measurement.offset]) /
          this.sliderItemOffset,
      ),
      1,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  getItems() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
  }

  // TODO: Clean this up
  getControlLinks(update = false) {
    if (!this.sliderControlWrapper) return;

    if (update) {
      const controlLinkSource = this.sliderControlWrapper
        .querySelector('.slider-counter__link')
        ?.cloneNode(true);

      if (!controlLinkSource) {
        console.error(
          'Could not find slider control link source. Add a single control link to dynamic sliders to allow for initialization',
        );
        return;
      }

      this.connectControlLinks(false);
      this.sliderControlWrapper.innerHTML = '';
      // TODO: Consider using sliderItemsToShow (would need to have standard update method for it regardless of dynamic sourcing)
      for (let i = 0; i < this.sliderItems.length; i++) {
        this.sliderControlWrapper.appendChild(
          controlLinkSource.cloneNode(true),
        );
      }
    }

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper?.querySelectorAll('.slider-counter__link') ??
        [],
    );

    if (update) {
      this.connectControlLinks();
    }
  }

  resetPages() {
    this.getItems();

    this.getControlLinks(true);
    this.initPages();
  }

  initOrientation() {
    this.verticalTarget = this.getAttribute('vertical') ?? false;

    switch (this.verticalTarget) {
      case 'true':
        this.isVertical = true;
        break;
      case false:
        this.isVertical = false;
        break;
      default:
        const queryString = breakpointQuery(this.verticalTarget);

        if (!queryString) {
          this.isVertical = false;
          break;
        }

        this.orientationMQL = window.matchMedia(queryString);
        this.orientationMQL.addEventListener(
          'change',
          this.handleOrientationChange,
        );
        this.isVertical = this.orientationMQL.matches;
        break;
    }

    this.updateOrientation();
  }

  // TODO: Clean up orientation handling & language
  changeOrientation(e) {
    this.isVertical = e.matches;
    this.updateOrientation();
  }

  updateOrientation() {
    this.classList.toggle('is-vertical', this.isVertical);
    this.slider.classList.toggle('is-vertical', this.isVertical);
    this.measurement = {
      scroll: this.isVertical ? 'scrollTop' : 'scrollLeft',
      offset: this.isVertical ? 'offsetTop' : 'offsetLeft',
      size: this.isVertical ? 'clientHeight' : 'clientWidth',
    };
  }

  updatePagination() {
    this.sliderControlLinksArray.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlLinksArray[this.currentPage - 1]?.classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlLinksArray[this.currentPage - 1]?.setAttribute(
      'aria-current',
      true,
    );
  }

  update() {
    if (!this.slider || this.locked) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider[this.measurement.scroll] / this.sliderItemOffset) +
      1;
    this.currentElements = this.sliderItemsToShow.slice(
      this.currentPage - 1,
      this.currentPage - 1 + this.slidesPerPage,
    );
    this.currentElement = this.sliderItemsToShow[this.currentPage - 1];

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElements: this.currentElements,
            currentElement: this.currentElement,
          },
        }),
      );
    }

    if (this.sliderControlLinksArray) this.updatePagination();

    if (this.enableSliderLooping) return;

    const prevButtonDisabled =
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider[this.measurement.scroll] === 0;
    const nextButtonDisabled = this.isSlideVisible(
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
    );

    if (this.prevButton) {
      if (prevButtonDisabled) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (nextButtonDisabled) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    this.slider.classList.toggle(
      'slider--inactive',
      prevButtonDisabled && nextButtonDisabled,
    );
  }

  onConnectedSlideChange(e) {
    if (this.isNavigating || e.srcElement.isNavigating || e.srcElement.isSlave)
      return;

    this.isSlave = true;
    this.goToSlide(e.detail.currentPage - 1, {
      onComplete: () =>
        setTimeout(() => (this.isSlave = false), SLIDE_CHANGE_DEBOUNCE_TIMER),
    });
  }

  onResize(entries) {
    this.throttledLock();
    this.debouncedResize();
  }

  lockPosition() {
    this.locked = true;
  }

  releaseLock() {
    this.locked = false;
  }

  lockAll() {
    this.lockPosition();
    this.connectedSliders.forEach(slider => slider.lockPosition());
  }

  releaseAll() {
    this.releaseLock();
    this.connectedSliders.forEach(slider => slider.releaseLock());
  }

  isSlideVisible(element, offset = 0) {
    if (!element || element[this.measurement.size] <= 0) return false;

    const lastVisibleSlide =
      this.slider[this.measurement.size] +
      this.slider[this.measurement.scroll] -
      offset;

    return (
      element[this.measurement.offset] + element[this.measurement.size] - 1 <=
        lastVisibleSlide &&
      element[this.measurement.offset] >= this.slider[this.measurement.scroll]
    );
  }

  runQueuedNavigation() {
    if (!this.navigationQueue.length) return;

    this.navigationQueue.shift()();
  }

  onButtonClick(event) {
    event.preventDefault();

    const button = event.target.closest('button');
    const step = button.dataset.step || 1;

    this.step(button.name, step);
  }

  step(direction, step = 1) {
    if (this.isNavigating) {
      console.debug(
        'Slider: Button clicked while navigating, enqueueing navigation event',
      );
      this.navigationQueue.push(this.step.bind(this, direction, step));
      return;
    }

    direction =
      direction === 'prev' || direction === 'previous'
        ? -1
        : direction === 'next'
          ? 1
          : direction;
    step = step * direction;

    if (
      this.currentPage + step > this.totalPages ||
      this.currentPage + step < 1
    )
      return;

    const targetSlide = this.currentPage + step - 1;

    this.isNavigating = true;
    this.goToSlide(targetSlide, {
      onComplete: () => {
        const timeout =
          this.navigationQueue.length > 0 ? 100 : SLIDE_CHANGE_DEBOUNCE_TIMER;
        setTimeout(() => {
          this.isNavigating = false;
          this.runQueuedNavigation();
        }, timeout);
      },
    });

    this.dispatchEvent(
      new CustomEvent('navigate', {
        detail: {
          type: 'navigation',
          currentPage: this.currentPage,
          destinationPage: this.currentPage + step,
          direction,
          step,
          currentElement: this.sliderItemsToShow[targetSlide],
        },
      }),
    );

    this.thumbnailSlider?.setActiveThumbnail(targetSlide);
    this.connectedSliders?.forEach(slider => {
      slider.isSlave = true;
      slider.goToSlide(targetSlide, {
        onComplete: () =>
          setTimeout(
            () => (slider.isSlave = false),
            SLIDE_CHANGE_DEBOUNCE_TIMER,
          ),
      });

      slider.dispatchEvent(
        new CustomEvent('navigate', {
          detail: {
            type: 'navigation',
            currentPage: slider.currentPage,
            destinationPage: slider.currentPage + step,
            direction,
            step,
            currentElement: slider.sliderItemsToShow[targetSlide],
          },
        }),
      );
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const index = this.sliderControlLinksArray.indexOf(event.currentTarget);

    this.isNavigating = true;
    this.goToSlide(index, {
      // TODO: Make this default onComplete?
      onComplete: () => {
        setTimeout(() => {
          this.isNavigating = false;
        }, SLIDE_CHANGE_DEBOUNCE_TIMER);
      },
    });

    this.dispatchEvent(
      new CustomEvent('navigate', {
        detail: {
          type: 'pagination',
          currentPage: this.currentPage,
          destinationPage: index + 1,
          currentElement: this.sliderItemsToShow[index],
        },
      }),
    );

    // TODO: Test
    this.connectedSliders?.forEach(slider => {
      slider.isSlave = true;
      slider.goToSlide(index, {
        onComplete: () =>
          setTimeout(
            () => (slider.isSlave = false),
            SLIDE_CHANGE_DEBOUNCE_TIMER,
          ),
      });

      slider.dispatchEvent(
        new CustomEvent('navigate', {
          detail: {
            type: 'pagination',
            currentPage: slider.currentPage,
            destinationPage: index + 1,
            currentElement: slider.sliderItemsToShow[index],
          },
        }),
      );
    });
  }

  // TODO: Add support for passing attributes to define duration args
  // TODO: Integrate connectedSliders with navigation (use isNavigating)!
  goToSlide(index, { jump = false, onComplete = null } = {}) {
    const target = this.sliderItemsToShow[index];

    if (!target) {
      console.debug(
        'Slider: Navigation failed, invalid slide index provided',
        this,
        index,
      );
      return;
    }

    const destination =
      target[this.measurement.offset] -
      this.sliderItemsToShow[0][this.measurement.offset];
    const axis = this.isVertical ? 'y' : 'x';
    const distanceMax =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1][
        this.measurement.offset
      ];
    const scrollDuration = calculateScrollDuration(
      this.slider[this.measurement.scroll],
      destination,
      { distanceMax },
    );

    gsap.to(this.slider, {
      ease: 'sine.inOut',
      duration: jump ? 0 : scrollDuration,
      scrollTo: { [axis]: destination },
      onComplete,
    });

    if (jump) this.update();
  }
}

customElements.define('slider-component', SliderComponent);

/**
 * !!!
 * TODO: Evaluate use or remove!
 * !!!
 */
// TODO: Update pagination to show all visible slides as active (figure out click event)
class CardSlider extends SliderComponent {
  constructor() {
    super();
    this.gridLayout = document.querySelector('grid-layout');
    this.onGridUpdate = this.updateGrid.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this.gridLayout.addEventListener('grid-update', this.onGridUpdate);
    // TODO: Consider implementing this on standard slider
    this.initObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.gridLayout.removeEventListener('grid-update', this.onGridUpdate);
    this.observer.disconnect();
  }

  static get observedAttributes() {
    return ['aria-hidden'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'aria-hidden') {
      if (!this.isHidden()) {
        this.updateGrid();
      }
    }
  }

  initObserver() {
    this.observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          this.resetPages();
        }
      }
    });

    this.observer.observe(this.slider, {
      childList: true,
    });
  }

  initPages() {
    this.releaseLock();

    if (!this.isActive()) {
      if (this.initialized) this.reset();

      return;
    }

    if (this.isHidden()) return;

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0,
    );

    this.slider.classList.toggle('is-active', this.isActive());

    if (this.sliderItemsToShow.length < 2) return;

    if (!this.initialized) this.init();

    this.update();
  }

  // TODO: Consider implementing orientation support (see SliderComponent)
  updateSliderVars() {
    this.sliderOffset = this.sliderItemsToShow[0].offsetLeft;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.sliderGap =
      this.sliderItemOffset - this.sliderItemsToShow[1].clientWidth;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderOffset * 2 + this.sliderGap) /
        this.sliderItemOffset +
        0.1,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
  }

  updateGrid() {
    if (!this.initialized) return;
    this.updateSliderVars();

    if (this.mm.contexts[0].conditions.matches) {
      this.sliderItemsToShow.forEach(slide => {
        this.updateSlideVisibility(slide);
      });

      this.refreshTimelines();
    }
  }

  updatePagination() {
    this.sliderControlLinksArray.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    let currentIndex = this.currentPage - 1;
    this.sliderControlLinksArray[currentIndex]?.setAttribute(
      'aria-current',
      true,
    );

    for (let i = 0; i < this.slidesPerPage; i++) {
      this.sliderControlLinksArray[currentIndex + i]?.classList.add(
        'slider-counter__link--active',
      );
    }
  }

  reset() {
    this.mm.revert();
    this.timelines = [];
    this.initialized = false;
  }

  init() {
    this.initialized = true;
    this.mm = gsap.matchMedia();
    this.updateSliderVars();
    this.createTimelines();

    this.dispatchEvent(
      new CustomEvent('sliderInitialized', {
        detail: {
          currentPage: this.currentPage,
          currentElements: this.currentElements,
          currentElement: this.currentElement,
        },
      }),
    );
  }

  isActive() {
    return this.slider.scrollWidth > this.slider.clientWidth;
  }

  isHidden() {
    return this.getAttribute('aria-hidden') === 'true';
  }

  updateSlideVisibility(slide, card) {
    card ??= slide.querySelector('.card-wrapper');
    const isHidden = !this.isSlideVisible(slide);

    card.classList.toggle('is-hidden', isHidden);

    if (isHidden) {
      gsap.set(card, { opacity: 0, scale: 0.95 });
    } else {
      gsap.set(card, { opacity: 1, scale: 1 });
    }
  }

  createTimelines() {
    // TODO: Replace with context and apply at all breakpoints! (mobile has extra item peeking)
    this.mm.add('(min-width: 750px)', () => {
      this.timelines = [];

      this.sliderItemsToShow.forEach(slide => {
        const card = slide.querySelector('.card-wrapper');

        this.updateSlideVisibility(slide, card);

        this.timelines.push(
          gsap
            .timeline({
              scrollTrigger: {
                trigger: slide,
                scroller: this.slider,
                horizontal: true,
                scrub: true,
                start: () => `left right-=${this.sliderOffset}px`,
                end: () => `right left+=${this.sliderOffset}px`,
              },
            })
            .to(card, {
              opacity: 1,
              scale: 1,
              ease: 'power1.in',
              onComplete: () => {
                card.classList.remove('is-hidden');
              },
            })
            .to(
              card,
              {
                opacity: 0,
                scale: 0.95,
                ease: 'power1.out',
                onComplete: () => {
                  card.classList.add('is-hidden');
                },
              },
              '+=2',
            ),
        );
      });
    });
  }

  disableTimelines() {
    this.timelines.forEach(timeline => timeline.scrollTrigger?.disable());
  }

  enableTimelines() {
    this.timelines.forEach(timeline => timeline.scrollTrigger?.enable());
  }

  toggleTimelines(enable) {
    if (enable) {
      this.enableTimelines();
    } else {
      this.disableTimelines();
    }
  }

  refreshTimelines() {
    this.timelines.forEach(timeline => {
      timeline.scrollTrigger?.refresh();
    });
  }

  // TODO: Consider implementing orientation support (see SliderComponent)
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth +
      this.slider.scrollLeft +
      this.sliderGap -
      this.sliderOffset -
      offset;

    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft + this.sliderOffset
    );
  }
}

customElements.define('card-slider', CardSlider);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.sliderControlWrapper) return;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.slider.removeEventListener(
      'scroll',
      this.setSlideVisibility.bind(this),
    );
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider[this.measurement.scroll] +
        this.sliderFirstItemNode[this.measurement.size] *
          this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    const direction = this.isVertical ? 'top' : 'left';
    this.slider.scrollTo({
      [direction]: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton?.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider[this.measurement.scroll] +
          this.slider.querySelector('.slideshow__slide')[this.measurement.size];
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

// TODO: Pass product ID on variant change
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.productId = this.dataset.productId;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach(mediaGallery =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`,
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`,
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`,
        );

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination)
          volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'hidden',
            skuSource.classList.contains('hidden'),
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            'hidden',
            pricePerItemSource.classList.contains('hidden'),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'hidden',
            inventorySource.innerText === '',
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            productId: this.productId,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked,
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/**
 * Subscription management page
 */
$(document).ready(function () {
  // Accordion logic for "subscription-faqs" section
  // TODO: Replace with standard accordion implementation or rework / remove page
  $('.subscription_question_tabs').click(function () {
    const answer = $(this).find('.subscription_question_ans');
    answer.slideToggle();

    const item = answer.closest('.subscription_question_tabs');
    item.toggleClass('is-open');
  });

  // Title change logic for rebuy widget (widget currently not visible)
  // TODO: Rework section / remove page
  var templateCheck = $('.itg_body').attr('data-handle');
  if (templateCheck == 'page.subscription-management') {
    // alert(templateCheck);
    // 'widget-type-product'
    function itgLoopForever() {
      if ($(document).find('.widget-type-product').length) {
        // console.log('1');
        if (
          $(document).find('.widget-type-product').find('.primary-title').length
        ) {
          var titleCheck = $(document)
            .find('.widget-type-product')
            .find('.primary-title');
          if (titleCheck.hasClass('itg-title-changed')) {
          } else {
            titleCheck.text('Subscribe & Save').addClass('itg-title-changed');
          }
        }
      }
    }
    var interval = self.setInterval(function () {
      itgLoopForever();
    }, 300);
  }
});

/**
 * Smooth scroll to anchor
 */
const header = document.querySelector('.section--header');
const stickyHeader = document.querySelector('sticky-header');
const initAnchor = anchor => {
  if (anchor.dataset.initialized) return;

  // TODO: Disable header reveal during scroll
  if (
    !/^#\D/.test(anchor.hash) ||
    EXCLUDED_ANCHOR_LINKS.includes(anchor.hash)
  ) {
    return;
  }

  if (anchor.hash.startsWith('#ProductInfo-')) {
    return;
  }

  if (anchor.classList.contains('skip-to-content-link')) {
    return;
  }

  const handler = function (e) {
    e.preventDefault();

    // Calculate scroll duration based on distance to target
    const anchorEl = document.querySelector(anchor.hash);
    const offset = parseInt(
      window.getComputedStyle(anchorEl).getPropertyValue('scroll-margin-top'),
      10,
    );
    smoothScroll(anchorEl, { offset });
  };

  anchor.addEventListener('click', handler);
  anchor.dataset.initialized = true;

  const remove = () => anchor.removeEventListener('click', handler);

  return { target: anchor, handler, remove };
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll(`a[href^="#"], a[href^="${window.location.pathname}#"]`)
    .forEach(initAnchor);
});

/**
 * mobile nav drawer 100vh fix
 */
const isMobileDevice =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

if (isMobileDevice) {
  let viewportWidth = window.innerWidth;
  let viewportHeight = window.innerHeight;

  window.addEventListener('resize', event => {
    const $target = event.target;

    if (viewportWidth !== $target.width) {
      viewportWidth = window.innerWidth;
      viewportHeight = window.innerHeight;
    }

    document.body.style.setProperty('--100vh', viewportHeight + 'px');
  });
}
